/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {connect} from 'react-redux'
import {updateTypesFilter} from '../../actions'

import {icons} from '../../helpers/google'



const styles = {
  root: css`
    padding: 10px 20px 20px 20px;

    h3 {
      font-weight: 600;
      margin-bottom: 15px;
    }
  `,
  optionContainer: css`
    display: flex;
    gap: 10px;
  `,
  option: css`
    cursor: pointer;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 150px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 5px;
    border: 2px solid black;

    p {
      text-transform: capitalize;
    }
  `,
  pin: css`
    width: 30px;
    margin-bottom: 10px;
  `
}




const MarkerVisibilityFilter = props => {
  const {map, types, updateTypesFilter} = props


  const handleClick = (type) => () => {
    if (types.includes(type)) {
      updateTypesFilter(types.filter(currentType => currentType !== type))
    } else {
      updateTypesFilter([...types, type])
    }
  }


  return (
    <div css={styles.root}>
      <h3>Show on Map</h3>

      <div css={styles.optionContainer}>
        {['venue', 'event'].map(type => {
          const pluralType = (type === 'venue') ? 'venues' : 'performances'

          return (
            <div 
              key={type}
              onClick={handleClick(pluralType)}
              css={styles.option} 
              style={
                types.includes(pluralType) ? {
                  border: '2px solid rgb(62, 166, 255)',
                  backgroundColor: 'rgb(62, 166, 255, 0.1)'
                } : {}
              }
            >

              <img src={icons[type]} css={styles.pin} alt={type + ' marker toggle'} />
              
              <p>{type + 's'}</p>
            </div>
          )
        })}
      </div>
    </div>
  )
}



const mapStateToProps = state => {
  return {
    map: state.map.map,
    types: state.search.filters.types
  }
}


export default connect(mapStateToProps, {updateTypesFilter})(MarkerVisibilityFilter)




